// src/services/emailAuditService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function getAuditLog(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return apiRequest(`${endpoints.EmailAuditLog}${qs ? `?${qs}` : ''}`, { method: 'GET' });
}
